function createPagedHits(hits, total, size, fill = 0) {
  const max = Math.ceil(hits.length / size);
  const pages = Array.from({ length: fill }, () => null);
  for (let i = 0; i < max; i++) {
    const start = i * size;
    const end = (i + 1) * size;
    const page = hits.slice(start, end);
    pages.push(page);
  }
  return {
    total,
    size,
    pages
  };
}
export {
  createPagedHits
};
//# sourceMappingURL=create-paged-hits.js.map
